module.exports = __webpack_public_path__ + "img/app-icon.f784c38.png";